import { api } from './api';
import { logIdentify, logEvent } from '../helpers/analytics';
import { trackEvent } from './trackEventActions';


export function fetchUser() {
  return dispatch => {
    return api.get('/api/users/current').then(response => {
      dispatch({ type: 'USER_FETCHED', payload: response.data });
    });
  };
}

export function assignInitialUser(data) {
  return dispatch => {
    dispatch({ type: 'USER_FETCHED', payload: data });
  };
}

export function preventFromGoingBack() {
  return dispatch => {
    return api
      .post('/api/users/prevent_from_going_back', {
        user: { prevented_from_going_back_to_quiz: true },
      })
      .then(response => {
        dispatch({ type: 'USER_FETCHED', payload: response.data });
      })
      .catch(error => {
        dispatch({ type: 'PREVENT_FROM_GOING_BACK_FAILURE', payload: error });
      });
  };
}

export function unsubscribeUser(unsubscribeReasons, unsubscribeOtherText) {
  return dispatch => {
    return api
      .post('/api/users/unsubscribe', {
        user: {
          unsubscribe_reasons: unsubscribeReasons,
          unsubscribe_other_text: unsubscribeOtherText,
        },
      })
      .then(response => {
        dispatch({ type: 'UNSUBSCRIBE_USER_SUCCESS', payload: response });
      })
      .catch(error => {
        dispatch({ type: 'UNSUBSCRIBE_USER_ERROR', payload: error.response });
      });
  };
}

export function claimGuestUser(first_name, last_name, email, phone, password) {
  return dispatch => {
    return api
      .post('/api/users/claim_guest', {
        user: {
          first_name: first_name,
          last_name: last_name,
          email: email,
          phone: phone,
          password: password,
        },
      })
      .then(response => {
        logIdentify(response.data.id, {
          firstName: response.data.first_name,
          lastName: response.data.last_name,
          phone: response.data.phone,
          email: response.data.email,
        });
        logEvent('RegistrationSuccess');
        dispatch({ type: 'CLAIM_GUEST_SUCCESS', payload: response.data });
        dispatch(trackEvent('SUBMITTED_CONTACT'));
      })
      .catch(error => {
        dispatch({ type: 'CLAIM_GUEST_FAILURE', payload: error.response.data });
      });
  };
}

export function signInUser(email, password) {
  return dispatch => {
    return api
      .post('/api/users/sign_in.json', {
        user: {
          email: email,
          password: password,
          remember_me: 1,
        },
      })
      .catch(error => {
        dispatch({ type: 'SIGN_IN_FAILURE', payload: error.response.data });
      });
  };
}

export function signOutUser(redirectPath) {
  return dispatch => {
    return api
      .delete('/api/users/sign_out.json')
      .then(response => {
        window.location.href = `${window.location.origin}${redirectPath}`;
      })
      .catch(error => {
        dispatch({ type: 'SIGN_IN_FAILURE', payload: error.response.data });
      });
  };
}

export function newGuestUser() {
  return dispatch => {
    return api.post('/api/users/new_guest').then(response => {
      window.location.reload();
    });
  };
}

export function animateSimulationOnboarding(animate) {
  return { type: 'ANIMATE_SIMULATION_ONBOARDING', payload: animate };
}
